import { useState } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import ExtendedFields from "ExtendedFields/ExtendedFields";
import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignupItemsCount } from "Signups/stateHooks";

import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

// TODO: We still need to do something with these.
import CopyToOtherItems from "./CopyToOtherItems/CopyToOtherItems";
import NextTab from "./NextTab/NextTab";

const ButtonsHolder = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SFnrVerticalGap = styled(FnrVerticalGap)`
  max-width: 560px;
  padding-bottom: 140px;
`;

const AdditionalInfo = () => {
  const { signupItemID } = useParams();
  const { isInCreationFlow } = useNewSignupCreationFlow();
  const count = useSignupItemsCount();
  const [hasExtendedFields, setHasExtendedFields] = useState(false);

  return (
    <SFnrVerticalGap gap={24}>
      <ExtendedFields
        signupItemId={Number(signupItemID)}
        syncHasExtendedFields={(value) => setHasExtendedFields(value)}
        variant="signup"
        editWithModal
      />
      <ButtonsHolder>
        {count > 1 && hasExtendedFields && !isInCreationFlow && (
          <CopyToOtherItems />
        )}
        {isInCreationFlow && <NextTab />}
      </ButtonsHolder>
    </SFnrVerticalGap>
  );
};

export default AdditionalInfo;
